<template>
  <InnerCardInfo
    v-if="id_data"
    :label="localStorage.translations.pages['setting-personal_area'].labels['id-nomer']"
    :images="id_data.image"
    need-image-domain
    :data="[
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['id-nomer'],
        value: text || '-',
      },
    ]"
    ref="inner"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot/>
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'

export default {
  name: 'IdNumberPdf',
  props: {
    editReady: Boolean,
    id_data: Object
  },
  components: { InnerCardInfo },
  data: () => ({
    file: '',
    imgUrl: null,
    text: null,
    image: [],
  }),
  watch: {
    id_data() {
      if (this.id_data) {
        this.text = this.id_data.text
        if (this.id_data.image !== undefined) {
          this.image = this.id_data.image
        }
      }
    },
  },
  mounted() {
    if (this.id_data) {
      this.text = this.id_data.text
      if (this.id_data.image !== undefined) {
        this.image = this.id_data.image
      }
    }
  },
}
</script>
